var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.002,
    cy: 15.1953,
    r: 15,
    fill: "#2F8AF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6218_22794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6218_22794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7342 14.9128L10.6659 8.87051C10.5713 8.82314 10.4651 8.80417 10.36 8.81586C10.2549 8.82755 10.1554 8.86942 10.0735 8.93643C9.99527 9.00207 9.9369 9.08825 9.90492 9.18528C9.87294 9.28232 9.86862 9.38637 9.89246 9.48573L11.5162 15.4017L9.87052 21.3012C9.84815 21.3841 9.84554 21.4712 9.86289 21.5554C9.88025 21.6395 9.91709 21.7185 9.97044 21.7858C10.0238 21.8531 10.0922 21.9069 10.1701 21.943C10.248 21.979 10.3333 21.9962 10.4191 21.9933C10.5049 21.9928 10.5895 21.9721 10.6659 21.9328L22.7342 15.8906C22.8241 15.8445 22.8995 15.7744 22.9521 15.6882C23.0048 15.6019 23.0327 15.5028 23.0327 15.4017C23.0327 15.3006 23.0048 15.2014 22.9521 15.1152C22.8995 15.0289 22.8241 14.9589 22.7342 14.9128ZM11.2693 20.4058L12.4817 15.951H17.5503V14.8524H12.4817L11.2693 10.3976L21.2586 15.4017L11.2693 20.4058Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6218_22794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2727,
    height: 17.2727,
    fill: "white",
    transform: "translate(9.09375 5.64844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6218_22794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8173,
    height: 15.8173,
    fill: "white",
    transform: "translate(8.09375 6.92969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCircle);
export default __webpack_public_path__ + "static/media/send_circle.d4d8f39b.svg";
export { ForwardRef as ReactComponent };